import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWall from '../components/Frontend/FameWall';
import Testimonial from '../components/Frontend/Testimonial';
import VideoTuts from '../components/Frontend/VideoTuts';
import WhyLove from '../components/Frontend/WhyLove';
import { Link} from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Slider from "react-slick";
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('2474090032742391');
        ReactPixel.init('197333187452630');
        ReactPixel.pageView();
    }
 render(){  
    const customslider = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
  };
    return (
    <React.Fragment>
    <Helmet>
        <title>PTE Speaking Test Practice Material| Language Academy</title>
        <meta name="description" content="Prepare for the PTE speaking test with Language Academy's PTE speaking test practice material . Enhance your fluency and confidence with targeted exercises and feedback." />
        <meta name="twitter:title" content="PTE Speaking Material for Practice | Best PTE Speaking Practice Test" />
        <meta name="og:title" content="PTE Speaking Material for Practice | Best PTE Speaking Practice Test" />
        <meta name="twitter:description" content="Are you facing issues in PTE Academic speaking module and worried about your exam score? No need to worry! With adequate practice and the right PTE speaking material, you can surely bolster your skills and ace this module in the exam. If you want the best PTE speaking practice test material & sample questions, or seeking expert assistance to attain your desired scores, contact us at info@languageacademy.com.au." />
        <meta property="og:description" content="Are you facing issues in PTE Academic speaking module and worried about your exam score? No need to worry! With adequate practice and the right PTE speaking material, you can surely bolster your skills and ace this module in the exam. If you want the best PTE speaking practice test material & sample questions, or seeking expert assistance to attain your desired scores, contact us at info@languageacademy.com.au." />
      </Helmet>
    <Header />
    <div className="hero-section mt-80">
      <div className="container">
          <div className="row">
          <div className="col-lg-8 col-md-8">
            <div className="hero-content">
                <h1 className="primary-heading mfw-600">
                  Brush up your <br className='d-none d-lg-block' /> English skills with <br className='d-none d-lg-block' /> the Best Online PTE <br className='d-none d-lg-block' /> Speaking practice test
                </h1>
                <p className="sub-heading bold-sub-heading">
                Avail the best PTE Speaking Material to practice,
                <br className='d-none d-md-block' />
                and score higher in the exam
                </p>
                <div className="text-center text-md-start">
                <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4">
            <div className="hero-img-wrapper">
                <img
                className="img-fluid"
                src="/images/web-new-images/bannerImg.png"
                alt="LA"
                />
            </div>
          </div>
          </div>
      </div>
    </div>
    <div className="pte-content-section wrsl-content-section">
      <div className="circle-section">
        <div className="container pte-container">
          <div className="row">
            <div className="col-md-12">                  
              <div className="position-relative">
                <ul className="m-0">
                    <li>
                    Many aspirants perform well in writing, reading, and speaking modules, but when it comes to the PTE speaking test module, they find themselves all at sea. When they try to speak in English, they feel as if they have suddenly run out of words despite having a lot of thoughts in mind. Do you also face difficulties in converting your ideas to speech, and find yourself fumbling in the English speaking test? Don't get disappointed! Adequate practice with the right PTE speaking material is the key to overcome these issues.
                    </li>
                </ul>
                {/* <img
                className="emoji-img"
                src="/images/web-new-images/emojis/smile-icon.png"
                alt="LA"
                /> */}
              </div>
              <div className="pte-bottom-content">
                <div>
                  <div onClick={this.handleClick} className="pte-bottom-header d-flex justify-content-center align-items-center">
                  <h3 className="m-0">
                    <a href="javascript:void(0)" className='text-decoration-none'>Read More</a>
                  </h3>
                  <img
                    src="/images/web-new-images/icons/bottom-arrow-01.png"
                    alt="LA"
                  />
                  </div>
                  <ul className={`hide-content ${this.state.isActive ? "active" : ""}`}> 
                    <li>
                    To boost your preparation and make yourself exam-ready, you need to practice a good number of PTE speaking sample questions so that you can avoid the long pauses or gaps while speaking in English. Moreover, you must couple your practice with a proper study plan, that includes attempting the mock tests or PTE speaking practice test sets at regular intervals, to accurately gauge your performance. For making a proper study plan to ace the exam, you can take guidance from the expert PTE trainers.
                    </li>
                    <li>
                    <span>Are you searching for the top PTE tutors who can assist you with formulating a proper preparation plan and picking the right PTE academic speaking practice test material? Call us on <a href="tel:+61426230061" target="blank">+61 426230061</a> and get solutions to all your exam related queries.</span>
                    </li>
                  </ul>
                </div>
              </div>								
            </div>
            <div className="text-center">
            <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
            </div>
          </div>
        </div>				
      </div>
    </div> 
    <div className="prepare-section wrsl-card-section">
      <div className="container">
          <div className="row">
          <div className="col-md-12">                
            <div className='prepare-cards'>
                <div className='position-relative'>
                <Link to="/pte-listening-test-practice-material"></Link>
                <div className='prepare-card listening-card'>
                  <div className="img-wrapper">
                      <img
                      src="/images/web-new-images//icons/language-01.png"
                      alt="LA"
                      />
                  </div>
                  <h2 className="card-title">Listening</h2>
                  <p className="card-description">
                  Start preparing for the listening section using the latest practice material.
                  </p>                      
                </div>
                </div>
                <div className='position-relative'>
                <Link to="/pte-writing-test-practice-material"></Link>
                <div className='prepare-card writing-card'>
                  <div className="img-wrapper">
                      <img
                      src="/images/web-new-images/icons/language-02.png"
                      alt="LA"
                      />
                  </div>
                  <h2 className="card-title">Writing</h2>
                  <p className="card-description">
                  Sharpen your writing skills with the best PTE writing practice material.
                  </p>                      
                </div>
                </div>
                <div className='position-relative'>
                <Link to="/pte-reading-test-practice-material"></Link>
                <div className='prepare-card reading-card'>
                  <div className="img-wrapper">
                      <img
                      src="/images/web-new-images/icons/language-04.png"
                      alt="LA"
                      />
                  </div>
                  <h2 className="card-title">Reading</h2>
                  <p className="card-description">
                  Get the intensive PTE reading practice material to skyrocket your score.
                  </p>                      
                </div>
                </div>
          </div>
          <div className="text-start text-md-center bottom-btn-wrapper">
                <p className="sub-heading ">
                Let’s make your learning meaningful and successful!
                </p>
                <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
            </div>
          </div>
      </div>
      </div>
    </div>
   
     <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern py-0">
              <div className="container">
                <div className="row">
                <h2 className="primary-heading text-center">
                Why People Love <br className='d-block' /><span className="wpl-badge pte-naati-badge text-white">Language Academy</span></h2> 
                <p className="sub-heading text-center">
                We provide the top-rated PTE training to the candidates <br className='d-none d-md-block' /> to make their career journey smooth
                </p>
                <div className="pattern-cards-outer mb-0">  
                  <div className="exam-pattern-cards position-relative">                
                    <Slider {...customslider}>
                    <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Experienced Trainer
                </h3>
                <p>We have Pearson certified faculty members...
                </p>                      
              </div>  
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Highest Success Rate</h3>
                <p>Students will get a sure-shot success with the high...
                </p>                      
              </div>         
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Free Books</h3>
                <p>Our PTE / NAATI training institute provides free books...
                </p>                      
              </div>         
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Latest Resources</h3>
                <p>Making use of the latest technology, we provide...
                </p>                      
              </div>     
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Online Support</h3>
                <p>Our experts are always there to help the students through...
                </p>                      
              </div>           
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">3500 + Questions to Practice</h3>
                <p>We give the students various exercises and practice
                </p>                      
              </div>         
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Discussion Sessions</h3>
                <p>During the discussion sessions, Our experienced team...
                </p>                      
              </div>        
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Affordable Fees</h3>
                <p>We offer the best PTE and NAATI coaching classNamees...
                </p>                      
              </div>         
              <div className="exam-pattern-card">
                <div className="img-wrapper">
                  <img
                    src="/images/web-new-images/icons/speaking-icon.svg"
                    alt="LA"
                  />
                </div>
                <h3 className="card-title">Real Time Test Environment</h3>
                <p>We provide several mock tests for reading, listening...
                </p>                      
              </div>                                
                    </Slider>
                  </div>
                  <div className="text-center">
                    <Link to="/auth/register" className="dark-border primary-btn">
                    REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </Link>
                  </div>
                </div>
                </div>
              </div>
            </div> 
    <Testimonial />
    <VideoTuts />
  <div className="faq-section mt-faq">
    <div className="container">
      <div className="row">
        <h2 className="secondary-heading text-center">
          Frequently Asked Questions
        </h2>

        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                What is the recommended number of PTE mock tests that I should undertake?
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
              It is recommended to take three complete PTE mock tests.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                What is the PTE requirement for canada?
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
              The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                What is the duration of a full-length PTE mock test?
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
              Around 2 hours. Students can attempt the test in one go or by taking short breaks.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <Footer />
    </React.Fragment>);
    }
}

export default Home;
